<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :loading="modalLoading"
      :data="queryDatabaseByGroupIdList"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="actions">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            @click="databaseDelModal = true"
            v-hasPermission="[
              'permissionsConfigurationManagement:resourcePermission:delete_database'
            ]"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>

    <Modal v-model="databaseDelModal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ Name }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          @click="deleteDatabase()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
var tableDatabases = {};
export default {
  name: "TableDatabases",
  props: ["receiveAccountType"],
  data() {
    return {
      accountType: "",
      accountName: "",
      databaseId: "",
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      Name: "",
      modalLoading: true,
      databaseDelModal: false,
      isDisable: false,
      state: [
        "creating",
        "available",
        "stopping",
        "stopped",
        "shutting down",
        "terminated",
        "running"
      ],
      columns: [
        {
          title: this.$t("alarms.database.accountName"),
          key: "accountName"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.accountType"
          ),
          key: "accountTypeName"
        },
        {
          title: this.$t("alarms.database.databaseId"),
          key: "databaseId"
        },
        {
          title: this.$t("alarms.database.engine"),
          key: "engine"
        },
        {
          title: this.$t("alarms.database.instanceType"),
          key: "type"
        },
        {
          title: this.$t("alarms.database.state"),
          key: "stateName"
        },
        {
          title: this.$t("alarms.database.region"),
          key: "region"
        },
        {
          title: this.$t("common.operation"),
          slot: "actions"
        }
      ],
      queryDatabaseByGroupIdList: []
    };
  },
  beforeCreate: function() {
    tableDatabases = this;
  },
  methods: {
    // 数据库列表
    queryDatabasesByGroupId: function() {
      eventBus.$on("databaseId", function(val) {
        tableDatabases.volumeId = val;
      });
      eventBus.$on("accountName", function(val) {
        tableDatabases.accountName = val;
      });
      eventBus.$on("accountType", function(val) {
        tableDatabases.accountType = val;
      });
      eventBus.$on("engineType", function(val) {
        tableDatabases.engineType = val;
      });
      tableDatabases.$api.groupDatabaseRelation
        .queryDatabaseByGroupId({
          groupId: this.$route.query.id,
          pageNum: this.current,
          pageSize: this.pageSize,
          databaseIdentifier: tableDatabases.volumeId,
          accountType: this.receiveAccountType,
          accountName: tableDatabases.accountName,
          engineType: tableDatabases.engineType || null
        })
        .then(res => {
          this.modalLoading = false;
          this.queryDatabaseByGroupIdList = res.data.records;

          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        })
        .catch(res => {
          // 如果列表里没数据 返回
          this.queryDatabaseByGroupIdList = undefined;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableDatabases.queryDatabasesByGroupId();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableDatabases.queryDatabasesByGroupId();
    },
    // 显示所有数据
    showAllDatabase: function() {
      tableDatabases.queryDatabasesByGroupId();
    },
    doDelete: function(index) {
      this.lineIndex = index;
      this.Name = this.queryDatabaseByGroupIdList[index].name;
    },
    // 删除database
    deleteDatabase: function() {
      this.isDisable = true; // 开始可以点击
      var lineIndex = this.lineIndex;
      // 删除实例
      tableDatabases.$api.groupDatabaseRelation
        .deleteByGroupIdAndDatabaseId({
          groupId: this.$route.query.id,
          databaseId: this.queryDatabaseByGroupIdList[lineIndex].id
        })
        .then(res => {
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableDatabases.queryDatabasesByGroupId();
            this.isDisable = false;
            this.databaseDelModal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/resource_permission/TableDatabases.vue